<template>
    <div>
        <center class="mb-8" data-aos="fade-in" data-aos-easing="linear">
            <slot v-if="$slots.header" name="header" />

            <template v-if="!$slots.header">
                <Heading
                    color="accent-gradiant"
                    class="f-w-600 mb-2 d-block"
                    tag="span"
                    size="x-sm"
                >
                    {{ subTitle }}
                </Heading>

                <Heading
                    color="primary"
                    class="f-w-700 mb-2 f-s-small-40 l-h-small-52"
                    tag="h2"
                    size="web-xx-lg"
                >
                    {{ headingText }}
                </Heading>
            </template>
        </center>
        <div class="row">
            <div class="col-md-6 col-lg-4 m-b-36 component-counter" v-for="(j, i) in items" :key="i" data-aos="fade-in" data-aos-easing="linear">
                <span class="font Roboto f-s-52 f-w-bold l-h-64 l-t-s-5 p-r-10 text-color accent accent-gradiant accent-gradiant-hover">0{{ i+1 }}</span>

                <div class="p-l-24 p-l-small-0">
                    <Heading
                        color="primary"
                        class="f-w-600 mb-2 "
                        tag="h5"
                        size="web-md"
                        style="letter-spacing: -0.75px;"
                    >
                        {{ j.title }}
                    </Heading>

                    <Texture
                        size="lg"
                        color="secondary"
                        class="font-normal"
                    >
                        {{ j.text }}
                    </Texture>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        headingText: {
            type: String,
            default: 'In-home product sampling journey',
        },
        subTitle: {
            type: String,
            default: 'How it works',
        },
        items: {
            type: Array,
            default: () => ([]),
        },
    },
};
</script>

<style lang="scss" scoped>
.component-counter {
    &:hover {
        .accent-gradiant-hover {
            &::after {
                left: calc(100% + 38px);
            }
        }
    }
    .accent-gradiant-hover {
        position: relative;
        overflow: hidden;
        &::after {
            content: "";
            transform: rotate(45deg);
            position: absolute;
            width: 10px;
            height: 65px;
            left: -34px;
            top: 0px;
            background: #FFFFFF;
            opacity: 0.3;
            transition: all 1s;
        }
    }
}
</style>
